import { useEffect, useState } from "react";
import { Download } from "lucide-react";
import { rpc } from "../../lib/rpc";
import { AdminPageHeader, DataTable, exportCsv } from "../../components/admin/DataTable";
import { Button } from "../../components/ui/button";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "../../components/ui/select";

const TYPES = ["all", "in", "out", "relocate", "adjustment", "loan", "return", "disposal", "pick", "lock", "unlock", "maintenance_in", "maintenance_out"];

export default function AdminAudit() {
    const [movements, setMovements] = useState([]);
    const [type, setType] = useState("all");

    useEffect(() => {
        const q = type && type !== "all" ? `?type=${type}&limit=500` : "?limit=500";
        rpc.get(`/movements${q}`).then((r) => r.ok && setMovements(r.data));
    }, [type]);

    const columns = [
        { key: "type", label: "Typ" },
        { key: "quantity", label: "Menge" },
        { key: "previous_quantity", label: "Vor" },
        { key: "new_quantity", label: "Nach" },
        { key: "reason", label: "Grund" },
        { key: "reference_type", label: "Ref." },
        { key: "reference_value", label: "Ref.Wert" },
        { key: "person", label: "Person" },
        { key: "comment", label: "Kommentar" },
        { key: "created_at", label: "Zeit", render: (r) => new Date(r.created_at).toLocaleString("de-DE") },
    ];
    return (
        <>
            <AdminPageHeader title="Audit" subtitle={`${movements.length} Bewegung(en)`}>
                <Button
                    variant="outline"
                    onClick={() => exportCsv(`platzwart-audit-${Date.now()}.csv`, movements, columns)}
                    data-testid="audit-export"
                >
                    <Download className="mr-1 h-4 w-4" /> CSV Export
                </Button>
            </AdminPageHeader>
            <DataTable
                testId="admin-audit-table"
                columns={columns}
                rows={movements}
                rowKey={(r) => r.id}
                search={(r) => `${r.comment || ""} ${r.reference_value || ""} ${r.person || ""}`}
                filtersSlot={
                    <Select value={type} onValueChange={setType}>
                        <SelectTrigger className="h-10 w-44" data-testid="audit-type-filter">
                            <SelectValue />
                        </SelectTrigger>
                        <SelectContent>
                            {TYPES.map((t) => (
                                <SelectItem key={t} value={t}>{t === "all" ? "alle Typen" : t}</SelectItem>
                            ))}
                        </SelectContent>
                    </Select>
                }
            />
        </>
    );
}
